/**
 * ErrorStep Component
 * FashPlay ve FashSnap akışlarında ortak hata ekranı
 */

import React from 'react';
import './ErrorStep.css';

export interface ErrorStepProps {
    error?: string | null;
    onRetry: () => void;
    retryLabel?: string;
    className?: string;
}

export const ErrorStep: React.FC<ErrorStepProps> = ({
    error,
    onRetry,
    retryLabel = 'Tekrar Dene',
    className = ''
}) => {
    return (
        <div className={`error-step ${className}`}>
            <div className="error-step__content">
                <span className="error-step__icon">😔</span>
                <h3 className="error-step__title">Bir şeyler yanlış gitti</h3>
                <p className="error-step__message">
                    {error || 'Bir hata oluştu. Lütfen tekrar deneyin.'}
                </p>
            </div>
            <div className="error-step__actions">
                <button className="error-step__retry-btn" onClick={onRetry}>
                    {retryLabel}
                </button>
            </div>
        </div>
    );
};

export default ErrorStep;
